import React from 'react';
import styled, { keyframes } from 'styled-components';

interface ProgressBarProps {
  progress: number;
  height?: string;
  borderRadius?: string;
  backgroundColor?: string;
}

const shine = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`;

const ProgressBarContainer = styled.div<{ height: string; borderRadius: string; backgroundColor: string }>`
  width: 100%;
  height: ${props => props.height};
  background-color: ${props => props.backgroundColor};
  border-radius: ${props => props.borderRadius};
  overflow: hidden;
`;

const ProgressFill = styled.div<{ progress: number }>`
  width: ${props => props.progress}%;
  height: 100%;
  background: linear-gradient(90deg, 
    #ff0000,
    #ff4500,
    #ff8c00,
    #ffa500
  );
  transition: width 0.3s ease;
  position: relative;
  overflow: hidden;
  border-radius: inherit;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.1) 100%
    );
    animation: ${shine} 2s infinite;
  }
`;

const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  height = '6px',
  borderRadius = '3px',
  backgroundColor = 'rgba(255, 255, 255, 0.3)'
}) => {
  const clampedProgress = Math.min(100, Math.max(0, progress));

  return (
    <ProgressBarContainer 
      height={height} 
      borderRadius={borderRadius}
      backgroundColor={backgroundColor}
    >
      <ProgressFill 
        progress={clampedProgress}
      />
    </ProgressBarContainer>
  );
};

export default ProgressBar; 